import { combineReducers } from 'redux';
import { serverAssignmentLocationsReducer } from './ServerAssignmentLocationsReducer';
import { serverAssignmentReducer } from './ServerAssignmentReducer';

export const tableServerAssignmentReducer = combineReducers({
  serverAssignmentLocations: serverAssignmentLocationsReducer,
  serverAssignments: serverAssignmentReducer,
});
